import { tns } from "tiny-slider";

export function subProductSliders() {
    let sliderBig = '.js-subproduct-gallery-large';
    let sliderSmall = '.js-subproduct-gallery-small';

    let largeSliderInstance = null;
    let smallSliderInstance = null;

    if (document.querySelector(sliderBig)) {
        largeSliderInstance = tns({
            container: sliderBig,
            items: 1,
            nav: false,
            controls: true,
            controlsContainer: document.querySelector('.js-gallery-small-controls'),
            mouseDrag: true,
            gutter: 30,
            loop: false
        });
    }

    if (document.querySelector(sliderSmall)) {
        smallSliderInstance = tns({
            container: sliderSmall,
            items: 1,
            slideBy: 1,
            nav: false,
            controls: false, // controls only needed once (on large slider)
            mouseDrag: true,
            gutter: 30,
            loop: false
        });
    }

    if (largeSliderInstance && smallSliderInstance) {
        const smallItems = document.querySelectorAll('.js-subproduct-gallery-small .tns-item');

        smallItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                largeSliderInstance.goTo(index);
                smallSliderInstance.goTo(index); // scroll thumbnail slider to same index
            });
        });

        // Optional: sync thumbnails as large slider changes (e.g., via arrows)
        largeSliderInstance.events.on('indexChanged', info => {
            smallSliderInstance.goTo(info.displayIndex - 1);
        });
    }

    return 'subProductSliders';
}
